import styled, { css } from 'styled-components';

import { HOME, MOBILE, SPACE } from '../../../../theme/tokens';
import { Text } from '../../../../components';
import { PinnedBar } from '../../../../components/PinnedBar';

/** The page column owns the inter-section gap; non-first headers add a touch more space above to read as a section
 *  break. */
const row = css<{ $first: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${(p) => (p.$first ? '0' : SPACE[8])};
`;

export const Root = styled.div<{ $first: boolean }>`
  ${row}
`;

/** The sticky header: the same row, in a PinnedBar, which pins it under the layout top bar and, once pinned, lifts it
 *  into the floating pill. */
export const PinnedRoot = styled(PinnedBar)<{ $first: boolean }>`
  ${row}
`;

export const TitleText = styled(Text)<{ $hideOnMobile?: boolean }>`
  font-size: 18px;
  font-weight: 700;
  color: ${HOME.t300};
  letter-spacing: -0.01em;

  ${(p) =>
    p.$hideOnMobile &&
    css`
      ${MOBILE} {
        display: none;
      }
    `}
`;
